import { createSlice } from '@reduxjs/toolkit';
import { REDUX_ASYNC_STATUSES } from '../../consts/consts';

const { IDLE, LOADING, SUCCEEDED, FAILED } = REDUX_ASYNC_STATUSES;

const initialState = {
  // collections
  customerPortalAvailability: false,
  customerPortalAvailabilityStatus: IDLE,

  customerPortalSession: null,
  customerPortalSessionStatus: IDLE
};

const stripeSlice = createSlice({
  name: 'stripe',
  initialState,
  reducers: {
    // collections
    getCustomerPortalAvailability(state) {
      state.customerPortalAvailabilityStatus = LOADING;
    },
    getCustomerPortalAvailabilitySucceeded(state, action) {
      state.customerPortalAvailability = action.payload?.available;
      state.customerPortalAvailabilityStatus = SUCCEEDED;
    },
    getCustomerPortalAvailabilityFailed(state) {
      state.customerPortalAvailabilityStatus = FAILED;
    },

    createCustomerPortalSession(state) {
      state.customerPortalSessionStatus = LOADING;
    },
    createCustomerPortalSessionSucceeded(state, action) {
      state.customerPortalSession = action.payload?.url;
      state.customerPortalSessionStatus = SUCCEEDED;
    },
    createCustomerPortalSessionFailed(state) {
      state.customerPortalSessionStatus = FAILED;
    }
  }
});

export const {
  getCustomerPortalAvailability,
  getCustomerPortalAvailabilitySucceeded,
  getCustomerPortalAvailabilityFailed,
  createCustomerPortalSession,
  createCustomerPortalSessionSucceeded,
  createCustomerPortalSessionFailed
} = stripeSlice.actions;

export default stripeSlice.reducer;
